// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"2a6c63a5","723":"bf51b30f"}[chunkId] + ".chunk.js";
};